import React from 'react';
import { useLocation } from 'react-router-dom';
import BookDetailView from '../../components/BookDetailView';

// Student Kitap İçeriği — thin wrapper over the shared <BookDetailView>. The
// teacher Kütüphanem renders the same component in read-only ('teacher') mode,
// so both roles share one three-column UI and one set of modals.
const StudentBookContent: React.FC = () => {
  const { state } = useLocation() as {
    state?: { bookId?: number; autoOpenSection?: string; autoOpenTestId?: number | null; autoStartTest?: boolean };
  };
  return (
    <BookDetailView
      mode="student"
      bookId={state?.bookId}
      autoOpenSection={state?.autoOpenSection}
      autoOpenTestId={state?.autoOpenTestId}
      autoStartTest={state?.autoStartTest}
    />
  );
};

export default StudentBookContent;
